import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'Seasons'

export const SeasonsEP : EndPointConfig[] =[
    new EndPointConfig()
        .setMethod('GET')
        .setController(controller)        
        .setActionName("GetSeasons")
]